import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Button from './Button';
import i18n from '../utils/i18n';
import { getParam, setParam } from '../localStorage';
import './styles/GDPRBanner.scss';

const GDPR_BANNER_DISMISSED_PARAM = 'GDPR_BANNER_DISMISSED_PARAM';

class GDPRBanner extends React.Component {
  constructor(props) {
    super(props);

    this.saveGdprBannerDismissed = this.saveGdprBannerDismissed.bind(this);
  }

  saveGdprBannerDismissed() {
    setParam(GDPR_BANNER_DISMISSED_PARAM, true);
    this.forceUpdate();
  }

  showGdprBanner() {
    return (
      this.props.showGdprBannerConfig && !getParam(GDPR_BANNER_DISMISSED_PARAM)
    );
  }

  render() {
    if (this.showGdprBanner()) {
      return (
        <div className="gdpr-banner">
          <div className="gdpr-text">
            {i18n.t('gdprBanner.WE_USE_COOKIES')}
            {' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://www.deucetennis.com/cookie-policy"
            >
              {i18n.t('gdprBanner.COOKIE_POLICY')}
            </a>
            .
          </div>
          <Button
            buttonClass="ok-button"
            text={ i18n.t('gdprBanner.OK') }
            onClick={ this.saveGdprBannerDismissed }
          />
        </div>
      );
    }
    return <div />;
  }
}

GDPRBanner.propTypes = {
  showGdprBannerConfig: PropTypes.bool
};

GDPRBanner.defaultProps = {
  showGdprBannerConfig: false
};

const mapStateToProps = state => ({
  showGdprBannerConfig: state.config.data.show_gdpr_banner
});

export default connect(
  mapStateToProps,
  null
)(GDPRBanner);



// WEBPACK FOOTER //
// ./src/components/GDPRBanner.js